/**
 * SWATI — single global entry point.
 *
 * Every SWATI module is a side-effect module that installs its own document-level listeners, so
 * the whole set is pulled in here and this file is the only thing that has to be loaded. Loading
 * is global (not template-scoped) for the same reason Horizon loads `variant-picker.js` and
 * `product-form.js` globally: a picker or a product form can be morphed into the page from a
 * section render at any time, and scripts inserted by a morph do not execute.
 *
 * Statically imported, never dynamically: static imports are checked by the import gate and share
 * one module instance with the `asset_url`-versioned specifiers in the importmap.
 *
 * Load order inside the graph matters in exactly one place: `@swati/product-form-hooks` wraps
 * `ProductFormComponent.prototype.handleSubmit`, and `@swati/simple-bundles` must have registered
 * its `shopify:product:select` listener before the hooks module registers its own, so the bundle
 * re-assert runs ahead of a deferred resubmit. Import order below is therefore load-bearing.
 */

import '@swati/promise-guard'; // first: guarantees upstream's deferred promise is always handled
import '@swati/simple-bundles';
import '@swati/variant-guard';
import '@swati/lenses-picker'; // pulls in @swati/product-form-hooks, @swati/globo-preorder, @swati/cart
import '@swati/dealeasy-bridge';
import '@swati/marquee-touch';
import '@swati/cart-pulse';
import '@swati/zoom-guard';
import '@swati/notifications';
import '@swati/quick-buy'; // CRO winner: quick buy on product cards (+ rendered by swati-quick-buy-trigger)
